import React from "react";
import {Row, Col } from 'react-bootstrap';
import  "./Subscribe.scss";
import BgShadowWhite from "../../../images/bg-shadow-white2.svg";

import NewsletterForm from '../../forms/newsletter-form'

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: -30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const Subscribe=()=> {
  return(
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.div
          className="subscribe-card justify-content-between align-items-center components-News-Subscribe-Subscribe"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <Row>
            <Col lg={6}>
              <h2 className="sec-title">Subscribe to our <span>newsletter<img loading="lazy" className="shadow-img shadow2" src={BgShadowWhite} alt="underline"/></span> to get updates straight to your inbox.</h2>
            </Col>
            <Col lg={6}>
              <NewsletterForm />
            </Col>
          </Row>  
        </motion.div>
      )}
    </InView>
  )
}
export default Subscribe
